const TIME_FORMATS = {
  ar: 'HH:mm',
  br: 'HH:mm',
  ca: 'HH:mm',
  cl: 'HH:mm',
  co: 'HH:mm',
  cr: 'HH:mm',
  do: 'HH:mm',
  ec: 'HH:mm',
  es: 'HH:mm',
  eu: 'HH:mm',
  fr: 'HH:mm',
  gb: 'HH:mm',
  gt: 'HH:mm',
  hn: 'HH:mm',
  jp: 'h:mm a',
  mx: 'HH:mm',
  ni: 'HH:mm',
  nl: 'HH:mm',
  pa: 'HH:mm',
  pe: 'HH:mm',
  sv: 'HH:mm',
  us: 'h:mm a',
  it: 'HH:mm',
};

const TIME_FORMATS_SHORT = {
  ar: 'HH:mm',
  br: 'HH:mm',
  ca: 'HH:mm',
  cl: 'HH:mm',
  co: 'HH:mm',
  cr: 'HH:mm',
  do: 'HH:mm',
  ec: 'HH:mm',
  es: 'HH:mm',
  eu: 'HH:mm',
  fr: 'HH:mm',
  gb: 'HH:mm',
  gt: 'HH:mm',
  hn: 'HH:mm',
  jp: 'h:mm',
  mx: 'HH:mm',
  ni: 'HH:mm',
  nl: 'HH:mm',
  pa: 'HH:mm',
  pe: 'HH:mm',
  sv: 'HH:mm',
  us: 'h:mm',
  it: 'HH:mm',
};

const WEEKDAY_WITH_MONTH_DAY = {
  ar: 'ddd DD MMM',
  br: 'ddd DD MMM',
  ca: 'ddd DD MMM',
  cl: 'ddd DD MMM',
  co: 'ddd DD MMM',
  cr: 'ddd DD MMM',
  do: 'ddd DD MMM',
  ec: 'ddd DD MMM',
  es: 'ddd DD MMM',
  eu: 'ddd DD MMM',
  fr: 'ddd DD MMM',
  gb: 'ddd DD MMM',
  gt: 'ddd DD MMM',
  hn: 'ddd DD MMM',
  jp: 'ddd MMM DD',
  mx: 'ddd DD MMM',
  ni: 'ddd DD MMM',
  nl: 'ddd DD MMM',
  pa: 'ddd DD MMM',
  pe: 'ddd DD MMM',
  sv: 'ddd DD MMM',
  us: 'ddd MMM DD',
  it: 'ddd DD MMM',
};

const DAY = 'DD';

const SHORT_MONTH_WITH_DAY = {
  ar: 'DD MMM',
  br: 'DD MMM',
  ca: 'DD MMM',
  cl: 'DD MMM',
  co: 'DD MMM',
  cr: 'DD MMM',
  do: 'DD MMM',
  ec: 'DD MMM',
  es: 'DD MMM',
  eu: 'DD MMM',
  fr: 'DD MMM',
  gb: 'DD MMM',
  gt: 'DD MMM',
  hn: 'DD MMM',
  jp: 'MMM DD',
  mx: 'DD MMM',
  ni: 'DD MMM',
  nl: 'DD MMM',
  pa: 'DD MMM',
  pe: 'DD MMM',
  sv: 'DD MMM',
  us: 'MMM DD',
  it: 'DD MMM',
};

const DAY_LONG_FORMAT = {
  ar: 'D MMMM YYYY',
  br: 'D MMMM YYYY',
  ca: 'D MMMM YYYY',
  cl: 'D MMMM YYYY',
  co: 'D MMMM YYYY',
  cr: 'D MMMM YYYY',
  do: 'D MMMM YYYY',
  ec: 'D MMMM YYYY',
  es: 'D MMMM YYYY',
  eu: 'D MMMM YYYY',
  fr: 'D MMMM YYYY',
  gb: 'D MMMM YYYY',
  gt: 'D MMMM YYYY',
  hn: 'D MMMM YYYY',
  mx: 'D MMMM YYYY',
  ni: 'D MMMM YYYY',
  nl: 'D MMMM YYYY',
  pa: 'D MMMM YYYY',
  pe: 'D MMMM YYYY',
  sv: 'D MMMM YYYY',
  us: 'MMMM D, YYYY',
  it: 'D MMMM YYYY',
};

const SHORT_MONTH_WITH_DAY_YEAR = {
  ar: 'DD MMM, YYYY',
  br: 'DD MMM, YYYY',
  ca: 'DD MMM, YYYY',
  cl: 'DD MMM, YYYY',
  co: 'DD MMM, YYYY',
  cr: 'DD MMM, YYYY',
  do: 'DD MMM, YYYY',
  ec: 'DD MMM, YYYY',
  es: 'DD MMM, YYYY',
  eu: 'DD MMM, YYYY',
  fr: 'DD MMM, YYYY',
  gb: 'DD MMM, YYYY',
  gt: 'DD MMM, YYYY',
  hn: 'DD MMM, YYYY',
  jp: 'MMM DD, YYYY',
  mx: 'DD MMM, YYYY',
  ni: 'DD MMM, YYYY',
  nl: 'DD MMM, YYYY',
  pa: 'DD MMM, YYYY',
  pe: 'DD MMM, YYYY',
  sv: 'DD MMM, YYYY',
  us: 'MMM DD, YYYY',
  it: 'DD MMM, YYYY',
};

const EXPIRATION_FORMATS = {
  ar: 'D MMMM, YYYY HH:mm',
  br: 'D MMMM, YYYY HH:mm',
  ca: 'D MMMM, YYYY HH:mm',
  cl: 'D MMMM, YYYY HH:mm',
  co: 'D MMMM, YYYY HH:mm',
  cr: 'D MMMM, YYYY HH:mm',
  do: 'D MMMM, YYYY HH:mm',
  ec: 'D MMMM, YYYY HH:mm',
  es: 'D MMMM, YYYY HH:mm',
  eu: 'D MMMM, YYYY HH:mm',
  fr: 'D MMMM, YYYY HH:mm',
  gb: 'D MMMM, YYYY HH:mm',
  gt: 'D MMMM, YYYY HH:mm',
  hn: 'D MMMM, YYYY HH:mm',
  jp: 'MMMM D, YYYY h:mm a',
  mx: 'D MMMM, YYYY HH:mm',
  ni: 'D MMMM, YYYY HH:mm',
  nl: 'D MMMM, YYYY HH:mm',
  pa: 'D MMMM, YYYY HH:mm',
  pe: 'D MMMM, YYYY HH:mm',
  sv: 'D MMMM, YYYY HH:mm',
  us: 'MMMM D, YYYY h:mm a',
  it: 'D MMMM, YYYY HH:mm',
};

const DATETIME_NO_TIMEZONE = 'YYYY-MM-DDTHH:mm:ss';

const DOB_LONG_FORMAT = {
  ar: 'Do MMMM YYYY',
  br: 'Do MMMM YYYY',
  ca: 'Do MMMM YYYY',
  cl: 'Do MMMM YYYY',
  co: 'Do MMMM YYYY',
  cr: 'Do MMMM YYYY',
  do: 'Do MMMM YYYY',
  ec: 'Do MMMM YYYY',
  es: 'Do MMMM YYYY',
  eu: 'Do MMMM YYYY',
  fr: 'Do MMMM YYYY',
  gb: 'Do MMMM YYYY',
  gt: 'Do MMMM YYYY',
  hn: 'Do MMMM YYYY',
  jp: 'MMMM D, YYYY',
  mx: 'Do MMMM YYYY',
  ni: 'Do MMMM YYYY',
  nl: 'Do MMMM YYYY',
  pa: 'Do MMMM YYYY',
  pe: 'Do MMMM YYYY',
  sv: 'Do MMMM YYYY',
  us: 'MMMM D, YYYY',
  it: 'Do MMMM YYYY',
};

const PAYMENT_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';

const TRACKING_FLIGHT_DATE_FORMAT = 'YYYYMMDD';

const DATE_YEAR_MONTH_DAY = 'YYYY-MM-DD';

const FLIGHT_STATUS_DROPDOWN_FORMAT = {
  ar: 'D [de] MMMM',
  br: 'D [of] MMMM',
  ca: 'D [of] MMMM',
  cl: 'D [de] MMMM',
  co: 'D [de] MMMM',
  cr: 'D [de] MMMM',
  do: 'D [de] MMMM',
  ec: 'D [de] MMMM',
  es: 'D [of] MMMM',
  eu: 'D [of] MMMM',
  fr: 'D [of] MMMM',
  gb: 'D [of] MMMM',
  gt: 'D [de] MMMM',
  hn: 'D [de] MMMM',
  jp: 'MMMM Do',
  mx: 'D [de] MMMM',
  ni: 'D [de] MMMM',
  nl: 'D [of] MMMM',
  pa: 'D [de] MMMM',
  pe: 'D [de] MMMM',
  sv: 'D [de] MMMM',
  us: 'MMMM Do',
  it: 'D [of] MMMM',
};


const GRANPLAN_FORMAT = 'YYYY/MM/DD';
const METRIC_FORMAT = 'DDMMYYYYTHH:mm:ss';
const METRIC_FORMAT_CLOSE = 'YYYYMMDDHHmmss';
const METRIC_FORMAT_DATE_TIME = 'YYYYMMDDHHmm';
const HERTZ_FORMAT = 'YYYY-MM-DD';
const HERTZ_FORMAT_TIME = 'HH:mm';
const HERTZ_FORMAT_LONGTIME = 'YYYY-MM-DDTHH:mm:ss';

export {
  DATE_YEAR_MONTH_DAY,
  DATETIME_NO_TIMEZONE,
  DAY,
  DOB_LONG_FORMAT,
  DAY_LONG_FORMAT,
  EXPIRATION_FORMATS,
  FLIGHT_STATUS_DROPDOWN_FORMAT,
  GRANPLAN_FORMAT,
  HERTZ_FORMAT,
  HERTZ_FORMAT_LONGTIME,
  HERTZ_FORMAT_TIME,
  METRIC_FORMAT,
  METRIC_FORMAT_DATE_TIME,
  METRIC_FORMAT_CLOSE,
  PAYMENT_DATE_TIME_FORMAT,
  SHORT_MONTH_WITH_DAY,
  SHORT_MONTH_WITH_DAY_YEAR,
  TIME_FORMATS,
  TIME_FORMATS_SHORT,
  TRACKING_FLIGHT_DATE_FORMAT,
  WEEKDAY_WITH_MONTH_DAY,
};
